import { NextPageWithLayout } from '@/common/common-types'
import PageLayout from '@/components/page-layout/page-layout'
import retriveMessages, { LocaleType } from '@/messages/message'
import { GetStaticPropsContext } from 'next'
import { ReactElement } from 'react'
import { useFlashBotArm } from '@/hooks/use-cc1-pro-data'
import { withSEO } from '@/common/with-seo'
import Section1 from './section1'
import Section2 from './section2'
import Section3 from './section3'
import Section4 from './section4'
import Section5 from './section5'
import Section6 from './section6'
import Section7 from './section7'
import Section8 from './section8'
import Section9 from './section9'
import Section10 from './section10'
import Section11 from './section11'
import Section12 from './section12'
import Section13 from './section13'
import Section14 from './section14'
import Section15 from './section15'
import PdFloatRobot from '@/components/pd-float-robot/pd-float-robot'
import { useLocale, useTranslations } from 'next-intl'
import { getProductBaseData, getProductDetailData, ProductDetailData } from '@/service/product'
import useSWR from 'swr'
import { MetaPage } from '@/common/meta-component-mgmt'
import { buildContactUsHref } from '@/common/contact-us-link'

const CC1Pro: NextPageWithLayout<{ productDetailData: ProductDetailData }> = ({ productDetailData }) => {
  const {
    section1Data,
    section2Data,
    section3Data,
    section4Data,
    section5Data,
    section6Data,
    section7Data,
    section8Data,
    section9Data,
    section10Data,
    section11Data,
    section12Data,
    section13Data,
    section14Data,
    section15Data,
  } = useFlashBotArm()
  const t = useTranslations()
  const locale = useLocale()
  const itemTitleTag = locale === 'zh-CN' ? 'p' : 'h3'
  const { data: productBaseData } = useSWR(getProductBaseData.swrkey(locale || '', 'cc1-pro'), () =>
    getProductBaseData('cc1-pro')
  )
  return (
    <>
      {productBaseData?.useDescription ? (
        <MetaPage productId="cc1-pro" initialData={productDetailData} />
      ) : (
        <div className="w-full h-fit bg-anti-blk">
          <Section1 {...section1Data} />
          <Section2 {...section2Data} />

          <Section3 {...section3Data} itemTitleTag={itemTitleTag} />
          <Section4 {...section4Data} />
          <Section5 {...section5Data} />
          <Section6 {...section6Data} />
          <Section7 {...section7Data} />
          <Section8 {...section8Data} />
          <Section9 {...section9Data} />
          <Section10 {...section10Data} />

          <Section11 {...section11Data} itemTitleTag={itemTitleTag} />
          <Section12 {...section12Data} />
          <Section13 {...section13Data} />
          <Section14 {...section14Data} />
          <Section15 {...section15Data} />
          <PdFloatRobot
            robot={'https://cdn.pudutech.com/official-website/product/CC1Pro/S1-3.webp'}
            color="#c0df16"
            href={buildContactUsHref('cc1-pro')}
            hideCircleBorder={true}
            buttonText={t('RequestDemo')}
            buttonTextSize="small"
            buttonTextColor="rgba(0,0,0,.9)"
          />
        </div>
      )}
    </>
  )
}

export const getStaticProps = withSEO(
  async ({ locale }: GetStaticPropsContext) => {
    const messages = retriveMessages(['product-cc1-pro', 'products'], locale as LocaleType)
    const productDetailData = await getProductDetailData('cc1-pro')
    return {
      props: {
        messages,
        productDetailData: productDetailData || [],
      },
      revalidate: 60,
    }
  },
  () => '/products/cc1-pro'
)

CC1Pro.getLayout = function (page: ReactElement, seo) {
  return (
    <PageLayout
      sticky={true}
      pageTitle={seo.title}
      pageDescription={seo.description}
      pageKeywrods={seo.keywords}
      ogtype={'website'}
    >
      {page}
    </PageLayout>
  )
}

export default CC1Pro
